var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8744 0.000152588H-0.00012207V80.8747H80.8744V0.000152588Z",
    fill: "#00D1AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3712 21.6129V29.1242H50.593V35.4462H43.8224V29.1242H37.0519V21.6129H30.2813V29.1242H23.5031V35.4462H16.7325V59.2614H23.5031V52.9393H30.2813V45.4203H37.0519V45.428V52.9393H43.8224V52.947V59.2537H50.593V52.9393H57.3712V45.4203H64.1417V21.6129H57.3712Z",
    fill: "#0B0E0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.8745,
    height: 80.8745,
    rx: 40.4373,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitflow);
export default __webpack_public_path__ + "static/media/bitflow.cd74e61da28507a627d82b00af989ca7.svg";
export { ForwardRef as ReactComponent };